import React, {useEffect} from 'react'
 import './testimonials.css'
 import {  Pagination, Autoplay } from 'swiper';
 import "swiper/css/autoplay";
 import { Swiper, SwiperSlide } from 'swiper/react';

 // Import Swiper styles
 import 'swiper/css';
 import AOS from 'aos'
 import 'aos/dist/aos.css'
 import 'swiper/css/pagination';
import client1 from '../../assets/client1.jpg'
import client2 from '../../assets/client2.jpg'
import client3 from '../../assets/client3.jpg'
import client4 from '../../assets/client4.jpg'
 const Testimonials = () => {
  useEffect(() => {
    AOS.init()
  })
   return (
     <section id='testimonials' >
       <h5 data-aos="fade-up">What My Clients Say</h5>
       <Swiper
       // install Swiper modules
     
       spaceBetween={40}
       slidesPerView={1}
       loop
        autoplay= {{
          delay: 8000,
          disableOnInteraction: false,
        }}
        modules={[ Autoplay]}
      //  pagination={{ clickable: true }}
      data-aos="fade-up"
     >
      <SwiperSlide>
        <div className="client_testimonial">
          <img src={client1} alt="" />
          <h2 className="client_name">Pierpaolo Tommasini</h2>
          <p className='client_review'>Kolapo is a highly skilled software developer who brings a positive and collaborative attitude to every project. He is an excellent team player and works well with others to deliver high-quality software products. His willingness to share his knowledge and expertise with other team members was invaluable to our project's success.</p>
        </div>
      </SwiperSlide>
       <SwiperSlide>
       <div className="client_testimonial">
          <img src={client2} alt="" />
          <h2 className="client_name">Ayeni Jeremiah</h2>
          <p className='client_review'>Kolapo is an outstanding software developer with exceptional technical skills. He was able to quickly understand our project requirements and develop a highly functional software application that met all our needs. His ability to problem-solve and find creative solutions to complex technical challenges was truly impressive.</p>
        </div>
       </SwiperSlide>
       <SwiperSlide>
       <div className="client_testimonial">
          <img src={client3} alt="" />
          <h2 className="client_name">Ogundiya Victor</h2>
          <p className='client_review'>Kola is an exceptional software developer with strong leadership and communication skills. He effectively managed a team of developers and successfully delivered a complex software project on time and within budget. His ability to communicate technical concepts to non-technical stakeholders was critical in ensuring that the project met all requirements and exceeded expectations.</p>
        </div>
       </SwiperSlide>
       <SwiperSlide>
       <div className="client_testimonial">
          <img src={client4} alt="" />
          <h2 className="client_name">Atsu John</h2>
          <p className='client_review'>Kola is a highly detail-oriented software developer who consistently delivers high-quality code. His attention to detail is evident in the software applications he develops, which are always well-designed, thoroughly tested, and free of errors. His meticulous approach to software development ensures that our products are of the highest quality and meet all client requirements.</p>
        </div>
        </SwiperSlide> 
     </Swiper>
      
    </section>
  )
 }

 export default Testimonials